import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Api from "../Api/Api.json";
import { md5Password } from "../utils";

import { inputClass, selectClass } from "../classes/class";
import { specailities, designations } from "../constants/doctorConstants";

const RegistrationPage = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const [serverError, setServerError] = useState("");
  const [serverSuccess, setServerSuccess] = useState("");

  const onSubmit = async (data) => {
    setServerError("");
    setServerSuccess("");

    if (data.password !== data.retypePassword) {
      setServerError("Passwords do not match.");
      return;
    }

    const body = {
      task: "registerDoctor",
      name: data.name,
      age: data.age,
      gender: data.gender,
      email: data.email,
      phone: data.number,
      address: data.address,
      password: md5Password(data.password),
      speciality: data.speciality,
      designation: data.designation,
      bmdc_no: data.reg_number,
      first_visit_rate: data.first_visit_rate || "1000",
      after1week_rate: data.after1week_rate || "400",
      after2week_rate: data.after2week_rate || "500",
      after1month_rate: data.after1month_rate || "600",
      after3month_rate: data.after3month_rate || "700",
    };

    console.log("Registration Data:", body);

    try {
      const response = await axios.post(Api.DOCTOR_API, body, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data === 200) {
        setServerSuccess("Successfully Signed Up. You can now log in.");
        reset();
      } else {
        setServerError("Error! Couldn't Signup.");
      }
    } catch (error) {
      setServerError("Something went wrong.");
    }
  };

  const color = "#229a88";

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 p-4 flex flex-col justify-center">
      <div className="bg-white shadow-md rounded-xl p-6 space-y-6">
        <h2 className="text-center text-2xl font-semibold text-[#229a88]">
          Doctor Signup
        </h2>

        {serverError && (
          <p className="text-red-600 text-sm text-center">{serverError}</p>
        )}
        {serverSuccess && (
          <p className="text-green-600 text-sm text-center">{serverSuccess}</p>
        )}

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="grid grid-cols-1 gap-4">
            <input
              type="text"
              placeholder="Name"
              {...register("name", { required: true })}
              className={inputClass}
            />
            <input
              type="number"
              placeholder="Age"
              {...register("age", { required: true })}
              className={inputClass}
            />
            <select
              {...register("gender", { required: true })}
              className={selectClass}
            >
              <option value="">Select Gender</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
            </select>
            <input
              type="email"
              placeholder="Email"
              {...register("email", { required: true })}
              className={inputClass}
            />
            <input
              type="text"
              placeholder="Address"
              {...register("address")}
              className={inputClass}
            />
            <input
              type="text"
              placeholder="Phone Number"
              {...register("number", {
                required: true,
                pattern: /^[0-9]{11}$/,
              })}
              className={inputClass}
            />
            <input
              type="password"
              placeholder="Password"
              {...register("password", { required: true })}
              className={inputClass}
            />
            <input
              type="password"
              placeholder="Re-type Password"
              {...register("retypePassword", { required: true })}
              className={inputClass}
            />
            <select
              {...register("speciality", { required: true })}
              className={selectClass}
            >
              <option value="">Select Speciality</option>
              {specailities.map((spec) => (
                <option key={spec} value={spec}>
                  {spec}
                </option>
              ))}
            </select>
            <select
              {...register("designation", { required: true })}
              className={selectClass}
            >
              <option value="">Select Designation</option>
              {designations.map((designation) => (
                <option key={designation} value={designation}>
                  {designation}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Registration Number"
              {...register("reg_number")}
              className={inputClass}
            />
            <input
              type="number"
              placeholder="First Visit Rate"
              {...register("first_visit_rate")}
              className={inputClass}
            />
            <input
              type="number"
              placeholder="After 1 Week Rate"
              {...register("after1week_rate")}
              className={inputClass}
            />
            <input
              type="number"
              placeholder="After 2 Weeks Rate"
              {...register("after2week_rate")}
              className={inputClass}
            />
            <input
              type="number"
              placeholder="After 1 Month Rate"
              {...register("after1month_rate")}
              className={inputClass}
            />
            <input
              type="number"
              placeholder="After 3 Months Rate"
              {...register("after3month_rate")}
              className={inputClass}
            />
          </div>

          <button
            type="submit"
            className="bg-[#229a88] text-white w-full py-2 rounded-lg hover:bg-[#1b7e6f] transition duration-200"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Signing Up..." : "Sign Up"}
          </button>

          <p className="text-center text-sm text-gray-500">
            Already have an account?{" "}
            <a href="/" className="text-[#229a88] font-semibold">
              Login
            </a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default RegistrationPage;
